export default {
      id: "physitrack-usage",
      viewBox: "0 0 23 22",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#physitrack",
      toString: function () {
        return this.url;
      }
    }